import "../stylesheets/helpingCenterPage.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { helpingCenterPage,helpingCenterPageHeading} from "../api/helping-center-page";
import Loading from "../components/loading";
import { DISPLAY_LANG } from "../config";

export default function HelpingCenterPage() {
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState([]);
  const [heading, setHeading] = useState({});

  useEffect(() => {
    const loadingData = async () => {
      try {
        const response = await helpingCenterPage();
        setPageData(response);
        const resHeading = await helpingCenterPageHeading();
        setHeading(resHeading[0].title);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    loadingData();
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="HelpingCenterPage wrapper">
      <h1 className="helpingCenter-title">{heading[DISPLAY_LANG]}</h1>

      <div className="helpingCenter-categories">
        {pageData &&
          pageData.map(
            (elem) =>
              elem.lang === DISPLAY_LANG && (
                <Link key={elem.id} to={`/helping-center/${elem.id}`}>
                  <div className="helpingCenter-category">
                    <h2>{elem.title}</h2>
                    <img
                      src="/images/partials/arrow-to-right.svg"
                      alt="arrow-to-right"
                    />
                  </div>
                </Link>
              ),
          )}
      </div>
    </div>
  );
}
